module.exports = __webpack_public_path__ + "static/img/mouse_icon.2a0bf6d0.svg";